import { GraphQLClient } from "graphql-request";
import { appConfig } from "../config";
import {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY,
  LOCAL_STORAGE_STORED_USER_KEY,
} from "../constants/localstorage";
import REFRESH_TOKEN from "./queries/refreshToken";

const endpoint = appConfig.api.graphQL;

const customGraphQLClient = new GraphQLClient(endpoint, {
  headers: {
    "X-GAIN-APPNAME": "learnpad",
  },
});

export const ONE_MIN = 1 * 60 * 1000;

export const refreshAccessToken = async (payload?: {
  onNoRefreshTokenError: () => void;
}) => {
  const { onNoRefreshTokenError } = payload ?? {};
  try {
    let refreshToken;
    try {
      refreshToken = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
      if (!refreshToken) throw new Error("Refresh Token could not be access");
    } catch (error) {
      if (onNoRefreshTokenError) {
        onNoRefreshTokenError();
      }
      throw error;
    }

    refreshToken = JSON.parse(refreshToken);
    const variables = {
      accessToken: refreshToken,
    };
    const response = await customGraphQLClient.request(
      REFRESH_TOKEN,
      variables
    );

    const newAccessToken = response.refreshToken.accessToken;
    const newRefreshAccessToken = response.refreshToken.refreshToken;

    localStorage.setItem(
      LOCAL_STORAGE_ACCESS_TOKEN_KEY,
      JSON.stringify(newAccessToken)
    );
    localStorage.setItem(
      LOCAL_STORAGE_REFRESH_TOKEN_KEY,
      JSON.stringify(newRefreshAccessToken)
    );
    localStorage.setItem(
      LOCAL_STORAGE_STORED_USER_KEY,
      JSON.stringify(response.refreshToken)
    );
    return newAccessToken;
  } catch (error) {
    throw error;
  }
};

export default customGraphQLClient;
